import React, { useState } from 'react';
import { Icon } from 'pepsico-ds';
import { cn } from '@/helpers/shadcn/utils';

const InfoPanel = ({
  title,
  children,
  isCollapsible = false,
  defaultOpen = false,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleOpen = () => {
    if (isCollapsible) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <div
      className={cn(
        'admin-profile_info-panel bg-gray-850 p-6 rounded-lg',
        className
      )}
      data-testid='info-panel'>
      <div
        className={cn(
          'admin-profile_info-panel-header flex justify-between items-center',
          {
            'border-b border-gray-700 pb-3 mb-4': !isCollapsible || isOpen,
            'collapsible': isCollapsible,
            'cursor-pointer': isCollapsible
          }
        )}
        onClick={toggleOpen}
        aria-expanded={isOpen}
        aria-controls='info-panel-content'
        role={isCollapsible ? 'button' : undefined}
        data-testid='info-panel-header'
        aria-label={
          isCollapsible
            ? `${isOpen ? 'Collapse' : 'Expand'} ${title} section`
            : undefined
        }>
        <h3 className='font-bold pl-4'>{title}</h3>
        {isCollapsible && (
          <span
            className='toggle-icon ml-4'
            aria-hidden='true'
            data-testid='info-panel-toggle-icon'>
            {isOpen ? (
              <Icon icon={'keyboard_arrow_up'} />
            ) : (
              <Icon icon={'keyboard_arrow_down'} />
            )}
          </span>
        )}
      </div>

      {(!isCollapsible || isOpen) && (
        <div
          className='admin-profile_info-panel-content'
          id='info-panel-content'
          data-testid='info-panel-content'>
          {children}
        </div>
      )}
    </div>
  );
};

export default InfoPanel;
